import { Store } from 'rxjs-observable-store';
import { CurrentPlaylist } from './models/current-playlist';
import * as i0 from "@angular/core";
export class CurrentPlaylistService extends Store {
    constructor() {
        super(new CurrentPlaylist());
    }
}
CurrentPlaylistService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CurrentPlaylistService_Factory() { return new CurrentPlaylistService(); }, token: CurrentPlaylistService, providedIn: "root" });
